module.exports = __webpack_public_path__ + "img/signup-carousel-second@3x.d6aba627.png";